import styled from 'styled-components';

export const Title = styled.span(({ theme }) => ({
  fontSize: theme.typography.size16,
  fontWeight: 500,
  letterSpacing: '0.2rem',
  flexGrow: 0,
  color: theme.palette.midGray,
  fontFamily: theme.typography.family.helvetica,
}));
